import { all } from 'redux-saga/effects'


const sagaWatchers = [];

const runner = function* () {
    yield all(sagaWatchers.map(fn => fn()));
}

export { runner };